module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("This book is about the most fascinating subject in the world: you. What makes you—and me—who we are? I have been captivated for years by the subject of identity, a topic that has become a major focus in religious, philosophical, and sociological fields, and rightly so, for identity is foundational for all of life. This book is intended for anyone willing to wrestle with identity, especially Christians. In focusing on identity, this book offers a chance for each of us to consider who we really are, what makes us that way, and who we should become. Nothing is more important than dealing with our own identity. I write as a New Testament scholar, not as a psychologist, psychiatrist, or philosopher, and I am not consciously Freudian or part of any other school of thought. I have drawn deeply, though, from several fields treating identity. I deal with identity because I must and because I am convinced that is what the Bible is really about. It seeks to tell us who God says we are.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Quotations from Greek and Latin classical writers are from the Loeb Classical Library, unless otherwise stated. The translations of the Scripture passages are my own, and part of the material in the chapters treating factors 1, 2, and 4 is adapted from lectures I gave at Dallas Theological Seminary that were later published as three articles: “Introduction to a Hermeneutics of Identity,” “Jesus and a Hermeneutics of Identity,” and “Paul’s Focus on Identity”—"), _c('i', [_vm._v("Bibliotheca Sacra")]), _vm._v(" 168 (January–March 2011): 3–19, (April–June 2011): 133–45, and (July–September 2011): 259–73, respectively. I thank the editors of "), _c('i', [_vm._v("Bibliotheca Sacra")]), _vm._v(" for permission to draw on this material.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Gratitude must also be expressed to several people who read part or all of the manuscript and provided reflection. They represent several arenas: social workers and sociologists, horse trainers, church leaders, pastors, theologians, editors, and seminary students. They include my daughter Valerie Luberecki, my brother Phil, Everett Anthony, Cathy Norman Peterson, Brian Tucker, Joel Johnson, Jenna Brand Frost, Peter Schwich, Stephen Spencer, Michael Emerson, and, most helpful of all, my wife Phyllis. No shortcoming of this book should be attributed to them, but such people have helped frame my own identity and in the process have made life extremely enjoyable. I am indebted to them.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("I also want to express my appreciation to the good people at Eerdmans for showing interest in my work and for helping to bring it to publication, especially James Ernest, Michael Thomson, and Jenny Hoffman.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b68aca4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 69
// module chunks = 0